









import { Component, Prop, Vue } from 'vue-property-decorator';
import { FutureEventsBlockDto } from '@/api';
import EventBlock from '@/views/cms/cmsref/EventBlock.vue';
import HeadingBlock from '@/views/cms/simple/HeadingBlock.vue';

@Component({
  components: {HeadingBlock, EventBlock},
})
export default class FutureEventsBlock extends Vue {
  @Prop({required: true})
  public readonly model!: FutureEventsBlockDto;

}
